
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-menu/[cName]/specials/offer/[specialId]",
      function () {
        return require("private-next-pages/embedded-menu/[cName]/specials/offer/[specialId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-menu/[cName]/specials/offer/[specialId]"])
      });
    }
  